import { render, staticRenderFns } from "./ProjectGrid.vue?vue&type=template&id=7a96ef74&scoped=true&"
import script from "./ProjectGrid.vue?vue&type=script&lang=js&"
export * from "./ProjectGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGrid.vue?vue&type=style&index=0&id=7a96ef74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a96ef74",
  null
  
)

export default component.exports